import React from 'react';
import PropTypes from 'prop-types';
import {
  FormGroup,
  Label,
  Input,
} from 'reactstrap';
import { useIntl } from 'react-intl';

const AccessModalNotifications = ({
  sendNotifications,
  handleChangeSendNotifications,
}) => {
  const intl = useIntl();

  return (
    <div className="access-notifications">
      <FormGroup check>
        <Label check>
          <Input
            type="checkbox"
            name="sendNotifications"
            value={true}
            checked={sendNotifications}
            onChange={handleChangeSendNotifications}
          />
          {' '}
          {intl.formatMessage({ defaultMessage: 'Notify teams and users' })}
        </Label>
      </FormGroup>
    </div>
  );
};

AccessModalNotifications.propTypes = {
  sendNotifications: PropTypes.bool.isRequired,
  handleChangeSendNotifications: PropTypes.func.isRequired,
};

export default AccessModalNotifications;
